package com.milta.feature.spreadsheetimport.domain.entity

/**
 * Response of `POST /api/v1/spreadsheet-imports` — a single synchronous file upload, server-side
 * AI column mapping, no session, no client-tracked attempt counter (contrat validé MIL-27, mockup
 * `docs/mockups/MIL-27.html`, écrans B-E). [isStructuredFormat] only changes the tone of the
 * banner shown on [com.milta.feature.spreadsheetimport.presentation.SpreadsheetValidationScreen]
 * (écran C vs D) — it does NOT skip row-by-row review, the driver always confirms explicitly.
 */
data class SpreadsheetImportResult(
    val totalCount: Int,
    val incompleteCount: Int,
    val isStructuredFormat: Boolean,
    val deliveries: List<ImportedDeliveryRow>,
)
